import styled from '@emotion/styled';
import { Form, Input, Button, Select, Alert, DatePicker, Drawer, Table, Dropdown, InputNumber, Tabs, Steps } from 'antd';

export const MForm = styled(Form)<{ bold?: boolean }>`
  .ant-form-item-label {
    label {
      font-weight: ${(props) => (props.bold ? 600 : 400)};
      font-size: 14px;
    }
  }
`;

export const MInput = styled(Input)`
  &.ant-input {
    padding: 6px 12px;
  }
  &.ant-input-affix-wrapper {
    padding: 6px 12px;
  }
`;

export const MInputDisable = styled(Input)`
  &.ant-input {
    padding: 6px 12px;
  }
  &.ant-input-affix-wrapper {
    padding: 6px 12px;
  }
  &.ant-input-disabled {
    background-color: #fff !important;
  }
`;

export const MSuffixInput = styled(Input)`
  &.ant-input-affix-wrapper {
    padding: 6px 12px;
  }
`;

export const MSearchInput2 = styled(Input)`
  .ant-input-group-addon {
    padding-left: 0;
    border: none;
  }
  .ant-input {
    border-top: none;
    border-left: none;
    border-right: none;
    box-shadow: none;
    border-radius: 0;
    border-color: rgba(11, 37, 86, 0.55);
  }
`;

export const MSearchInput = styled(Input)`
  &.ant-input-affix-wrapper {
    border-radius: 20px;
    padding: 6px 12px;
  }
`;

export const MLoginInput = styled(Input)<{ small?: boolean }>`
  &.ant-input-affix-wrapper {
    font-size: 16px;
    padding: 6px 18px;
    height: ${(props) => (props.small ? '46px' : '52px')};
    min-height: ${(props) => (props.small ? '46px' : '52px')};
    border-radius: ${(props) => (props.small ? '8px' : '12px')};
  }
  .ant-input-prefix {
    margin-inline-end: 10px;
  }
`;
export const MLoginInputNoIcon = styled(Input)<{ small?: boolean }>`
  font-size: 16px;
  padding: 12px 18px;
  height: ${(props) => (props.small ? '46px' : '52px')};
  border-radius: ${(props) => (props.small ? '8px' : '12px')};
  .ant-input-prefix {
    margin-inline-end: 10px;
  }
`;

export const MInputBlack = styled(Input)`
  &.ant-input {
    padding: 6px 12px;
    background-color: #f3f3f3 !important;
    border: none !important;
    box-shadow: none !important;
  }
`;

export const MInputNumber = styled(InputNumber)`
  &.ant-input-number {
    width: 100%;
  }
  &.ant-input-number-group-wrapper {
    width: 100%;
  }
  .ant-input-number-input {
    padding: 6px 12px;
  }
`;
export const MInputNumberBlack = styled(InputNumber)`
  &.ant-input-number {
    width: 100%;
    background-color: #f3f3f3 !important;
    border: none !important;
    box-shadow: none !important;
  }
  .ant-input-number-input {
    padding: 6px 12px;
  }
`;

export const MPassword = styled(Input.Password)`
  &.ant-input {
    padding: 6px 14px;
  }
`;

/** 内敛按钮，仅做点击使用 */
export const MInlineButton = styled(Button)`
  &.ant-btn {
    font-size: 14px;
    height: 20px;
    line-height: 1;
    padding: 0;
  }
`;

export const MButton = styled(Button)<{ small?: boolean }>`
  &.ant-btn {
    font-size: 14px;
    height: 40px;
    line-height: 1;
    padding: ${(props) => (props.small ? '0 20px' : '0 32px')};
  }
`;
export const MButtonReset = styled(Button)`
  &.ant-btn {
    font-size: 14px;
    height: 40px;
    line-height: 1;
    padding: 0 32px;
    background-color: rgba(204, 204, 204, 1) !important;
    color: #fff !important;
    margin-left: 16px;
  }
`;
export const MButtonSmall = styled(MButton)`
  &.ant-btn {
    height: 35px;
    padding: 0 20px;
  }
`;

export const MButtonSmallReset = styled(Button)`
  &.ant-btn {
    font-size: 14px;
    height: 35px;
    line-height: 1;
    padding: 0 20px;
    background-color: rgba(204, 204, 204, 1) !important;
    color: #fff !important;
    margin-left: 16px;
  }
`;

export const MButtonCancel = styled(Button)`
  &.ant-btn {
    font-size: 14px;
    height: 40px;
    line-height: 1;
    padding: 0 32px;
  }
  &.ant-btn-default {
    border: 1.5px solid rgba(22, 119, 255, 1);
    color: rgba(22, 119, 255, 1);
    margin-right: 25px;
  }
`;

export const MButtonCancelSmall = styled(MButtonCancel)`
  &.ant-btn {
    height: 32px;
    padding: 0 26px;
  }
  &.ant-btn-default {
    border-width: 1px;
    margin-right: 20px;
  }
`;

// 了解更多按钮
export const MButtonTips = styled(Button)`
  &.ant-btn {
    font-size: 12px;
    height: 24px;
    line-height: 1;
    padding: 0 8px;
    display: inline-flex;
    align-items: center;
    background-color: rgba(230, 244, 255, 1);
    color: rgba(12, 111, 252, 1);
    &:hover {
      background-color: rgba(230, 244, 255, 1) !important;
      color: rgba(12, 111, 252, 1) !important;
      opacity: 0.8;
    }
  }
  .ant-btn-icon {
    margin-inline-end: 3px !important;
  }
`;

export const MSelect = styled(Select)`
  .ant-select-selector {
    height: 36px !important;
  }
  .ant-select-selection-search-input {
    height: 36px !important;
  }
  .ant-select-selection-placeholder,
  .ant-select-selection-item {
    line-height: 36px !important;
  }
`;

export const MSelectBlack = styled(Select)`
  .ant-select-selector {
    height: 36px !important;
    background-color: #f3f3f3 !important;
    border: none !important;
    box-shadow: none !important;
  }
  .ant-select-selection-search-input {
    height: 36px !important;
  }
  .ant-select-selection-placeholder,
  .ant-select-selection-item {
    line-height: 36px !important;
  }
`;

export const MSelectCircle = styled(Select)<{ minWidth?: number }>`
  .ant-select-selector {
    height: 30px !important;
    min-width: ${(props) => (props.minWidth ? `${props.minWidth}px` : '160px')};
    border-radius: 30px;
  }
  .ant-select-selection-search-input {
    height: 30px !important;
  }
  .ant-select-selection-item {
    opacity: 0.65 !important;
  }
`;

export const MSelectPrefix = styled(Select)`
  .ant-select-selector {
    height: 30px !important;
    width: 75px !important;
    border: none !important;
    box-shadow: none !important;
  }
  .ant-select-selection-item {
    overflow: visible !important;
  }
`;

export const MSelectPrefix2 = styled(Select)<{ small?: boolean }>`
  height: ${(props) => (props.small ? '46px' : '52px')} !important;
  .ant-select-selector {
    height: ${(props) => (props.small ? '46px' : '52px')} !important;
    width: 100% !important;
    box-shadow: none !important;
    border-radius: ${(props) => (props.small ? '8px' : '12px')};
  }
  .ant-select-selection-item {
    overflow: visible !important;
    display: flex;
  }
`;

export const MSelectPrefixMax = styled(Select)`
  .ant-select-selector {
    height: 30px !important;
    /* width: 85px !important; */
    border: none !important;
    box-shadow: none !important;
  }
  .ant-select-selection-item {
    overflow: visible !important;
  }
`;

export const MAlert = styled(Alert)`
  &.ant-alert {
    border-radius: 4px;
    .ant-alert-message {
      opacity: 0.65;
    }
  }
  &.ant-alert-success {
    border-color: rgba(217, 247, 190, 1);
    background-color: rgba(246, 255, 237, 1);
  }
  &.ant-alert-info {
    border-color: rgba(186, 224, 255, 1);
    background-color: rgba(230, 244, 255, 1);
    .ant-alert-message {
      opacity: 0.65;
    }
  }
`;

export const MDatePicker = styled(DatePicker)`
  &.ant-picker {
    width: 100%;
    padding: 6px 12px;
  }
`;

export const MDrawer = styled(Drawer)`
  .ant-drawer-header-title {
    justify-content: flex-end;
  }
  .ant-drawer-header {
    border: none;
  }
  .ant-drawer-close {
    margin-inline-end: 0;
  }
  .ant-drawer-body {
    padding: 0px 24px 24px 24px;
  }
`;

export const MTable = styled(Table)<any>`
  .ant-table-thead {
    .ant-table-cell {
      background-color: rgba(22, 119, 255, 0.05);
      color: rgba(0, 0, 0, 0.65);
      font-weight: normal;
      padding: 10px 20px;
      border-bottom: none;
      /* margin-bottom: 20px; */
      &:first-child {
        border-start-start-radius: 8px;
        border-end-start-radius: 8px;
      }
      &:last-child {
        border-end-end-radius: 8px;
      }
    }
  }
  .ant-table-tbody {
    .ant-table-cell {
      border-bottom: none;
      color: rgba(0, 0, 0, 0.65);
    }
  }
`;

export const MDropdown = styled(Dropdown)`
  padding: 6px 6px;
  .ant-dropdown-menu-item {
    padding: 6px 6px;
    &:hover {
      background-color: #f2f6ff !important;
    }
  }
`;
export const MTabs = styled(Tabs)`
  .ant-tabs-tab-btn {
    font-size: 18px;
    opacity: 0.65;
    color: #000000;
  }
  .ant-tabs-tab-active {
    .ant-tabs-tab-btn {
      opacity: 1;
      font-weight: 700;
      color: #000000 !important;
    }
  }
  .ant-tabs-content {
    height: 100%;
  }
  .ant-tabs-tabpane-active {
    height: 100%;
  }
`;


export const MTabs2 = styled(Tabs)`
  .ant-tabs-nav::before {
    border: none !important;
  }
`;

export const MSteps = styled(Steps)`
  .ant-steps-item-title {
    white-space: nowrap;
  }
`;
